import React, { useEffect, useState } from 'react';
import { useGetReptoolByNameQuery } from '../../features/reptool/reptoolFetch';
import { Icon } from "@vds/icons";
import { Button } from "@vds/buttons";
import styled from 'styled-components';
import { ScrollWrapper } from "@vds-core/scrollbars";
import { Tabs, Tab } from "@vds/tabs";
import { Title } from '@vds/typography';
import DeviceSpecific from './DeviceSpecific';
import PlanInfo from './planinfo';
import InternationalDialingInstrcution from './dialinginstruction';
import {setReptoolOpened} from '../../features/selectedData/persistantDataReducer';
import { useSelector, useDispatch } from 'react-redux';
import ErrorPage from '../../shared/components/ErrorPage';
import FullPageLoader from '../../shared/components/Loader';
import {  getDestList } from '../../shared/utils/globalUtils';
import ComponentLoader from './ComponentLoader';
import { nsaItpMultipleDeviceRepToolFFlag } from '../utils/globalConfig';

const RedModelWrapper = styled.div`
z-index:9999;
position:fixed;
bottom:0;
right:0;
top:100px;
height:calc(80% - 30px);
width:800px; 
display:flex;
width: ${({ opened }) => opened ? '840px' : '50px'};

`
const AlertStyle = styled.div`
display: block; 
top: calc(50% - 150px);
transform: rotate(90deg);
width: 44px;
height: 58px;
 
`;
const SecondaryButton = styled(Button)`
position:relative;
font-size: 12px;
height: 32px;
width:100px;
border-radius: 5px;
margin-left:60px;
padding 0px;
span{
    padding : 4px!important;
    transform: rotate(180deg);
    top: 3px; 
  }
}
`;
const DialogDiv = styled.div`
background-color: rgb(255, 255, 255);
    box-sizing: border-box;
    display: flex;
    flex-flow: column nowrap;    
   
    min-height: 14.5rem;
    position: relative;
   
    outline: none;
    
    padding: 40px;
    flex:1;
`
const StyledDivWrapper = styled.div`
display:flex;
justify-content: space-between;
padding-bottom:48px;

`;
const StyledTabs1 = styled(Tab)`
width:35%
`;

const PaddingDiv4 = styled.div`
padding-bottom:52px;
`;
const StyledTabs2 = styled(Tab)`
width:25%
`;

export const StyledTabs3 = styled(Tab)`
width:40%
`;

export default function Reptool({ deviceSelectionData }) {

   
    const [openInternationalTools, setOpenInternationalTools] = useState(false);
    const [selectedTabIndex, setSelectedTabIndex] = useState();
    const [repToolData, setReptoolData] = useState();
    const dispatch = useDispatch();
    const {reptoolOpened,selectedDestinations} = useSelector(state => state?.persistantReducer);

    const getUniqueDevices = (deviceSelectionData) => {
        if (deviceSelectionData) {
           const uniquedevices = deviceSelectionData?.filter((deviceDetailInfo, index, self) => 
                 index === self.findIndex((t) => (
                    t?.productDisplayName === deviceDetailInfo?.productDisplayName)

            )
        );
        return uniquedevices
          
        } 
    }
    const frameUniqueDevices = (uniqueDevices) => {
        let item = []
        let subItem = {}
        uniqueDevices?.map((el, i) => {
            
                 subItem = {
                    "brandName": el?.brandName,
                    "deviceName": el?.deviceNickName,
                    "deviceTypeCategory": el?.deviceTypeCategory,
                    "skuId": el?.skuId,
                    "smartPhone": el?.smartPhone,
                    "basicPhone": el?.basicPhone,
                    "tablet": el?.tablet,
                    "operatingSystem": el?.operatingSystem,
                    "productDisplayName" : el?.productDisplayName
                }
                item.push(subItem);
            }
        )
            return item;
    }
    const getReptoolPayLoad = () => {
        let uniqueDevices = getUniqueDevices(deviceSelectionData);
        let payload = {
            'destinations': getDestList(selectedDestinations, 'key'),
            'flowName': 'outsideUs',
            'uniqueDevices': frameUniqueDevices(uniqueDevices)
        }
        return payload;
    }

    const onOpenInternationRepTool = () => {
        if (openInternationalTools) {
            setOpenInternationalTools(false);
            setReptoolOpened(false)
        }
        else {
            setReptoolOpened(true)
            setOpenInternationalTools(true);
        }
    }

    const { data, error, isLoading, isSuccess } = useGetReptoolByNameQuery(getReptoolPayLoad(),{ skip: !openInternationalTools && !reptoolOpened });


    useEffect(() => {
        setReptoolData(data?.body?.data);

    }, [data]);

    const onTabChange = (event, ActiveTabIndex) => {
        setSelectedTabIndex(ActiveTabIndex)
    }


    return (
        <RedModelWrapper opened={openInternationalTools} id="device_page">
            <AlertStyle>
                <SecondaryButton
                    size="medium" onClick={() => onOpenInternationRepTool()}
                    data-testid="repToolButtonId"
                    data-clickstream="Rep Tools"
                    data-track="Rep Tools"
                    data-analyticsTrack="Rep Tools">
                    <Icon
                        name="retail-store"
                        color="white"
                        style={{ paddingRight: "14px" }}
                        size="small"
                    />
                    {'Rep Tools'}

                </SecondaryButton>
            </AlertStyle>
            <DialogDiv>
            {(isSuccess && repToolData) ?
            (<>{openInternationalTools &&

                <>
                    <div>
                        <button
                            data-clickstream="Close"
                            data-track="Close"
                            data-analyticsTrack="Close"
                            data-testid="repModalCloseButtonId"
                            onClick={() => onOpenInternationRepTool()}
                            style={{ background: 'none', border: '0px', float: 'right', paddingBottom: "10px" }}>X</button>
                    </div>
                    {
                        <>
                            <ScrollWrapper
                                height={"100%"}
                                width={"100%"}
                                contentStyle={{
                                    display: "flex",
                                    flexDirection: "column",
                                    paddingRight: 26,
                                }}
                            >
                                <StyledDivWrapper>
                                    <Title size="large" bold="true">
                                        {repToolData?.title}
                                    </Title>
                                </StyledDivWrapper>
                                <Tabs
                                    selectedIndex={selectedTabIndex}
                                    orientation="horizontal"
                                    indicatorPosition="bottom"
                                    onTabChange={(event, ActiveTabIndex) => onTabChange(event, ActiveTabIndex)}>

                                    <StyledTabs1 label={repToolData?.deviceSpecificRepo?.tabName}
                                        data-clickstream="Device-specific details"
                                        data-track="Device-specific details"
                                        data-analyticsTrack="Device-specific details" >
                                       {nsaItpMultipleDeviceRepToolFFlag  && <DeviceSpecific
                                            deviceSpecific={repToolData?.deviceSpecificRepo}></DeviceSpecific>}
                                        <PaddingDiv4></PaddingDiv4>
                                    </StyledTabs1>

                                    <StyledTabs2 label={repToolData?.planInfo.tabName}
                                        data-clickstream="Plan Info"
                                        data-track="Plan Info"
                                        data-analyticsTrack="Plan Info" >
                                        <PlanInfo
                                            planInfo={repToolData?.planInfo}></PlanInfo>
                                        <PaddingDiv4></PaddingDiv4>
                                    </StyledTabs2>

                                    <StyledTabs3 label={repToolData?.dialingInstructionInfo?.tabName}
                                        data-clickstream="Int'l Dialing Instructions"
                                        data-track="Int'l Dialing Instructions"
                                        data-analyticsTrack="Int'l Dialing Instructions" >
                                        <InternationalDialingInstrcution
                                            dialingInstruction={repToolData?.dialingInstructionInfo}></InternationalDialingInstrcution>
                                        <PaddingDiv4></PaddingDiv4>
                                    </StyledTabs3>

                                </Tabs>
                            </ScrollWrapper>
                        </>


                    }
                </>
            }</>) 
            : (error && <ErrorPage errorDetails={error?.data} />)
            }  
            {isLoading && <ComponentLoader />} 
            </DialogDiv>  
            </RedModelWrapper>
    )
} 